import React, { useState } from "react";
import { ReactComponent as CheckIcon } from "../../../../../assects/svg/client_details/check-circle.svg";
import { ReactComponent as CrossIcon } from "../../../../../assects/svg/client_details/cross-circle.svg";
import { ReactComponent as ArrowUpRight } from "../../../../../assects/svg/client_details/ArrowUpRight.svg";
import Drawer from "./Drawer";
import { Supplement } from "../../../hooks/useAllLogsData";

interface SupplementsCardProps {
  supplements: Supplement[];
  selectedDate?: string;
}

const SupplementsCard: React.FC<SupplementsCardProps> = ({ supplements, selectedDate }) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const formatTime = (hour: number, minute: number, period: string): string => {
    const paddedHour = hour.toString().padStart(2, "0");
    const paddedMinute = minute.toString().padStart(2, "0");
    return `${paddedHour}:${paddedMinute} ${period}`;
  };

  const renderSupplementEntry = (supplement: Supplement) => {
    const isTaken = supplement.status === "1";
    const time = formatTime(supplement.hour, supplement.minute, supplement.period);

    // =========================================================================
    // OLD: supplement.supplement_name, supplement.when_to_take
    const name = supplement.medicine_name;
const instruction = `${supplement.before_after_meal} ${supplement.meal_type.toLowerCase()}`;
    //
    // NEW: supplement.medicine_name, supplement.before_after_meal
    // const name = supplement.medicine_name;
    // const instruction = `${supplement.before_after_meal} ${supplement.meal_type.toLowerCase()}`;
    // =========================================================================

    return (
      <div className="flex items-start gap-2">
        {isTaken ? (
          <CheckIcon className="w-5 h-5 3xl:w-6 3xl:h-6 flex-shrink-0" />
        ) : (
          <CrossIcon className="w-5 h-5 3xl:w-6 3xl:h-6 flex-shrink-0" />
        )}
        <div className="flex-1">
          <p className="text-[12px] 3xl:text-sm font-medium font-inter text-[#1F1F1F]">
            {name}{" "}
            <span className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
              • {time}
            </span>
          </p>
          <p className="text-[10px] 3xl:text-[12px] font-medium font-inter text-[#8D8D8D]">
            {instruction}
          </p>
        </div>
      </div>
    );
  };

  const displayedSupplements = supplements.slice(0, 2);

  if (!supplements || supplements.length === 0) {
    return (
      <div className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full">
        <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase mb-4">
          SUPPLEMENTS
        </h3>
        <div className="flex-1 flex items-center justify-center min-h-[92px]">
          <p className="text-sm font-medium text-[#646464] font-inter">No entries yet</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <div onClick={() => setIsDrawerOpen(true)} className="bg-white rounded-md shadow-sm p-4 flex flex-col h-full cursor-pointer">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-[12px] 3xl:text-sm font-semibold font-inter text-[#1F1F1F] uppercase">
            SUPPLEMENTS
          </h3>
          <button
            
            className="p-1 hover:bg-gray-100 rounded-lg transition-colors"
            aria-label="View all supplements"
          >
            <ArrowUpRight className="w-4 h-4 3xl:w-5 3xl:h-5 text-[#1F1F1F]" />
          </button>
        </div>

        <div className="flex-1 min-h-[92px]">
          {displayedSupplements.map((supplement, index) => (
            <React.Fragment key={index}>
              {renderSupplementEntry(supplement)}
              {index < displayedSupplements.length - 1 && (
                <div className="w-full border-t border-gray-200 my-2.5"></div>
              )}
            </React.Fragment>
          ))}
        </div>
      </div>

      <Drawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        title="Supplements"
        selectedDate={selectedDate}
      >
        <div className="space-y-3">
          {supplements.map((supplement, index) => (
            <div key={index} className="pb-3 border-b border-gray-100">
              {renderSupplementEntry(supplement)}
            </div>
          ))}
        </div>
      </Drawer>
    </>
  );
};

export default SupplementsCard;